import { Injectable } from "@angular/core";
import { PlatformService } from "@obg/ngx.global";

import { PlatformName } from "../app-context/app-context.model";

/**
 * @deprecated [fabric-deprecated] -  Use StartupContextService instead.
 */
@Injectable({
	providedIn: "root",
})
export class OperatingSystemService {
	private platformName: PlatformName;

	constructor(private platformService: PlatformService) {
		if (this.platformService.isServer) {
			this.platformName = PlatformName.Unknown;
			return;
		}
		const userAgent = navigator.userAgent || navigator.vendor;

		// Windows Phone must come first because its UA also contains "Android"
		if (/windows phone/i.test(userAgent)) {
			this.platformName = PlatformName.WindowsPhone;
			return;
		}

		if (/android/i.test(userAgent)) {
			this.platformName = PlatformName.Android;
			return;
		}

		// iOS pre 13 (iPad|iPhone|iPod) - MacIntel (iPad iOS 13)
		if (/iPad|iPhone|iPod/.test(userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)) {
			this.platformName = PlatformName.IOS;
			return;
		}

		if (/windows nT|xP/i.test(userAgent)) {
			this.platformName = PlatformName.Windows;
			return;
		}

		if (/mac os x (\d+(\.?_?\d+)+)/i.test(userAgent)) {
			this.platformName = PlatformName.MacOSX;
			return;
		}

		this.platformName = PlatformName.Unknown;
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ConfigServiceValue.OperatingSystem instead.
	 */
	getOperatingSystem(): PlatformName {
		return this.platformName;
	}
}
